import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import CustomToast from '../../components/CustomToast';
import LoadingOverlay from '../../components/LoadingOverlay';
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';
import * as selector from '../../../common/selectors';
import * as registrationAction from '../../../common/actions/registration';
import AuthManager from '../../../utils/AuthManager';
import CustomText from '../../components/CustomText';
import CustomModal from '../../components/CustomModal';
import { Grid } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CheckIcon from '@material-ui/icons/Check';
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";

// Simple regex
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: "2rem",
        // paddingLeft: '2.7rem',
        // paddingRight: '2.7rem',
        [theme.breakpoints.down('sm')]: {
            paddingTop: "0rem",
            paddingLeft: '0rem',
            paddingRight: '0rem',
            width: "90% !important",
            margin: "auto !important"
        },
    },
    headerText: {
        color: '#171717',
        fontSize: 24,
        fontWeight: 700,
        [theme.breakpoints.down('sm')]: {
            fontSize: 24,
        },
    },
    labelTextInputTextStyle: {
        fontWeight: 500,
        fontSize: 14,
        color: '#171717',
        [theme.breakpoints.down('sm')]: {
            fontSize: 13,
        },
    },
    labelTextInputTextStyleError: {
        fontWeight: 500,
        fontSize: 14,
        color: '#EF4444',
    },
    labelTextInputTextStyleSuccess: {
        fontWeight: 500,
        fontSize: 14,
        color: '#10B981',
    },
    textInputContainer: {
        height: 48,
        marginBottom: 25,
        marginTop: 5,
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: 'none',
    },
    textInputContainerError: {
        height: 48,
        marginBottom: 0,
        marginTop: 5,
        border: '1px solid #EF4444',
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    textInputContainerStrongPassw: {
        height: 48,
        marginBottom: 0,
        marginTop: 5,
        border: '1px solid #10B981',
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    textInputContainerDis: {
        height: 48,
        marginBottom: 25,
        marginTop: 5,
        backgroundColor: "#F2F2F2",
        color: '#B1B1B1',
    },
    errorTextStyle: {
        marginTop: 0,
        marginBottom: 15,
    },
    successTextStyle: {
        marginTop: 0,
        marginBottom: 15,
        color: '#10B981',
    },
    inputContentContainer: {
        marginTop: '1.5rem',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
        flexDirection: 'column',
    },
    buttonStyle: {
        height: '48px',
        backgroundColor: '#FFC107',
        color: '#FFFFFF',
        [theme.breakpoints.down('sm')]: {
            height: '44px',
        },
    },
    modalDesign: {
        padding: 0,
        paddingLeft: 15,
        paddingRight: 15,
        paddingBottom: 5,
        textAlign: 'center',
        [theme.breakpoints.down("xs")]: {
            minWidth: 200,
            marginTop: 20,
            marginBottom: 20,
        },
        [theme.breakpoints.up("sm")]: {
            minWidth: 200,
        },
        [theme.breakpoints.up("lg")]: {
            minWidth: 250,
            maxWidth: 250,
        },
        textInputStyle: {
            height: 35,
            marginLeft: 5,
            marginRight: 5,
        },
        containerStyle: {
            flexGrow: 1,
            marginBottom: 30,
            paddingRight: 20,
            marginBottom: 30
        },
        tooltipContainer: {
            display: "flex",
            alignItems: "center",
        },
        titleTextStyle: {
            fontWeight: 'bold',
            fontSize: 25,
        },
    },
    disableBtnStyle: {
        height: '56px',
        backgroundColor: '#F2F2F2 !important',
        color: '#B8BABC !important',
        // [theme.breakpoints.down('sm')]: {
        //     height: '44px',
        // },
        border: 'none !important'
    },
}));

const CreateUserIDPass = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    // --------------------------
    // Local States
    // --------------------------
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [retypePassword, setRetypePassword] = useState('');
    // Validation states
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isRetypePasswordMatch, setIsRetypePasswordMatch] = useState(true);
    // Touched states
    const [idTouched, setIdTouched] = useState(false);
    const [idValid, setIdValid] = useState(false);
    const [passwordTouched, setPasswordTouched] = useState(false);
    const [retypeTouched, setRetypeTouched] = useState(false);
    // Form errors
    const [formErrors, setFormErrors] = useState({
        userId: false,
        password: false,
        retypePassword: false,
    });
    // Other states
    const [submitted, setSubmitted] = useState(false);
    const [customToastStatus, setCustomToastStatus] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [countdown, setCountdown] = useState(300); // 5 minutes
    const [backToHome, setBackToHome] = useState(false)
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRetypePassword, setShowRetypePassword] = useState(false);
    const updateClientInfoV4Data = useSelector(selector.updateClientInfov4RequestData);
    const updateClientInfoV4Loading = useSelector(selector.updateClientInfov4RequestLoading);

    const getLoginTokenData = useSelector(selector.getLoginTokenData);
    const getLoginTokenLoading = useSelector(selector.getLoginTokenLoading);

    const customerDetails = useSelector(selector.getRegistrationCustomerDetailsData);
    const customerDetailsLoading = useSelector(selector.getRegistrationCustomerDetailsLoading);
    const customerDetailsStatus = useSelector(selector.getRegistrationCustomerDetailsStatus);
    const [calledApi, setCalledApi] = useState(false);
    // --------------------------
    // Countdown Timer
    // --------------------------
    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    history.push("/"); // Redirect to home when time is up
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [history]);
    // --------------------------
    // Handle Redux Response
    // --------------------------
    useEffect(() => {
        if (updateClientInfoV4Loading) return;

        if (updateClientInfoV4Data && calledApi) {
            setCalledApi(false)
            const success = updateClientInfoV4Data.Success;
            const status = updateClientInfoV4Data.Data?.Status;
            if (success && status === 'SUCCESS') {
                // proceed to getLoginToken
                const regId = localStorage.getItem('registrationId');
                dispatch(registrationAction.getLoginToken({ RegistrationId: regId }));
                setCalledApi(true)
            } else {
                setCustomToastStatus(true);
                setToastMessage(updateClientInfoV4Data.Data?.ErrorMessage || 'User ID is not available, please re-enter.');
                setSubmitted(false);
            }
        }
    }, [updateClientInfoV4Data]);

    // Handle getLoginTokenData
    useEffect(() => {
        // if (!submitted) return;
        if (getLoginTokenLoading) return;

        if (getLoginTokenData && calledApi) {
            setCalledApi(false)
            if (getLoginTokenData.Success) {
                const loginData = getLoginTokenData.Data;
                const token = loginData.token;
                const needSetUserID = loginData.need_set_user_id;
                const isMasterAccount = loginData.is_master_account;
                const sessionExpiryWarning = loginData.session_expiry_warning;
                const sessionExpiryEnd = loginData.session_expiry_end;
                const isDirectClient = loginData.direct_client;
                const sessionId = loginData.session_id;
                AuthManager.setToken(token);
                AuthManager.setSetChangeUserID(needSetUserID);
                AuthManager.setIsMasterAccount(isMasterAccount);
                AuthManager.setDirectClient(isDirectClient);
                AuthManager.setSessionID(sessionId);
                AuthManager.setExpiryWarning(sessionExpiryWarning);
                AuthManager.setExpiryEnd(sessionExpiryEnd);
                window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
                localStorage.setItem("IsFirstTimeLogin", true)
            } else {
                setCustomToastStatus(true);
                setToastMessage('Login failed. Please try again.');
            }
            setSubmitted(false);
        }
    }, [getLoginTokenData]);
    // --------------------------
    // Validation Handlers
    // --------------------------
    const handleChooseIdChange = (val) => {
        setUserId(val);
        if (!idTouched && val.length > 0) {
            setIdTouched(true);
        }
        if (val.length > 0) {
            const minLengthValid = val.length >= 8;
            const allowedCharsValid = /^[A-Za-z0-9@_.-]+$/.test(val);
            const isNotNRIC = !/^[STFG]\d{7}[A-Z]$/i.test(val);
            setIdValid(minLengthValid && allowedCharsValid && isNotNRIC);
        } else {
            setIdValid(false);
        }
    };
    const handlePasswordChange = (val) => {
        setPassword(val);
        if (!passwordTouched && val.length > 0) {
            setPasswordTouched(true);
        }
        if (val.length > 0) {
            setIsPasswordValid(passwordRegex.test(val));
        } else {
            setIsPasswordValid(false);
        }
        setIsRetypePasswordMatch(val === retypePassword);
    };
    const handleRetypePasswordChange = (val) => {
        setRetypePassword(val);
        if (!retypeTouched && val.length > 0) {
            setRetypeTouched(true);
        }
        setIsRetypePasswordMatch(password === val);
    };
    // --------------------------
    // Field Validation
    // --------------------------
    const validateFields = () => {
        return {
            userId: !userId || !idValid,
            password: !password || !isPasswordValid,
            retypePassword: !retypePassword || !isRetypePasswordMatch,
        };
    };
    const onClickConfirm = () => {
        const errorsFound = validateFields();
        console.log("errorsFounderrorsFound", errorsFound)
        setFormErrors(errorsFound);
        if (Object.values(errorsFound).some(val => val)) {
            setCustomToastStatus(true);
            setToastMessage("Please fill in all required fields correctly.");
            return;
        }
        console.log("errorsFounderrorsFound2", errorsFound)
        // Assuming previous data is stored or fetched, here we mock the data payload
        // You may need to adjust to include previously collected data like name, email, etc.
        const data = {
            RegistrationId: localStorage.getItem('registrationId'),
            UserId: userId,
            Password: password,
            ConfirmPassword: retypePassword,
        };
        dispatch(registrationAction.updateClientInfov4Request(data));
        setCalledApi(true)
        setSubmitted(true);
    };
    // --------------------------
    // Toast Close Handler
    // --------------------------
    const handleCloseCustomToast = (event, reason) => {
        if (reason === 'clickaway') return;
        setCustomToastStatus(false);
    };
    // Toggle password visibility
    const handleClickShowPassword = () => {
        setShowPassword(prev => !prev);
    };
    const handleClickShowRetypePassword = () => {
        setShowRetypePassword(prev => !prev);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    // --------------------------
    // Render Page
    // --------------------------
    const renderPage = () => {
        const chooseIdTextStyle = (formErrors.userId || (idTouched && !idValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const chooseIdDesign = (formErrors.userId || (idTouched && !idValid)) ? classes.textInputContainerError : classes.textInputContainer;
        const passwordTextStyle = (classes.labelTextInputTextStyle);
        const passwordDesign = (classes.textInputContainer);
        const retypeTextStyle = (formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const retypeDesign = (formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)) ? classes.textInputContainerError : classes.textInputContainer;
        const errors = validateFields();
        const isFormInvalid = Object.values(errors).some(val => val);
        return (
            <div className={classes.container} style={{ width: "490px" }}>
                <div className={classes.headerText}>
                    Create your User ID and Password
                </div>
                <div className={classes.inputContentContainer}>
                    {/* UserID */}
                    <CustomTextInput
                        title="User ID"
                        textstyle={chooseIdTextStyle}
                        design={disabledBtn ? classes.textInputContainerDis : chooseIdDesign}
                        fullWidth
                        value={userId}
                        onChange={(e) => {
                            handleChooseIdChange(e.target.value);
                            setFormErrors(prev => ({ ...prev, userId: false }));
                        }}
                        error={formErrors.userId || (idTouched && !idValid)}
                        //errorMessage="Invalid UserID. Check requirements."
                        errorTextStyle={classes.errorTextStyle}
                        borderline={false}
                        disabled={disabledBtn}
                    />
                    {idTouched && !(idValid) && (
                        <div style={{ marginBottom: 15, marginTop: -10 }}>
                            <CustomText style={{ marginTop: 0, fontWeight: 'bold' }}>
                                Username requirements:
                            </CustomText>
                            <div style={{ marginLeft: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {userId.length >= 8 ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: userId.length >= 8 ? '#10B981' : '#EF4444', fontWeight: '400' }}>Minimum 8 characters</CustomText>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {/^[A-Za-z0-9@_.-]+$/.test(userId) ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: /^[A-Za-z0-9@_.-]+$/.test(userId) ? '#10B981' : '#EF4444', fontWeight: '400' }}>Only letters, numbers and '@' / '_' / '-' / '.' can be used</CustomText>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {!/^[STFG]\d{7}[A-Z]$/i.test(userId) ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: !/^[STFG]\d{7}[A-Z]$/i.test(userId) ? '#10B981' : '#EF4444', fontWeight: '400' }}>Username cannot be NRIC</CustomText>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Password */}
                    <CustomTextInput
                        title="Password"
                        textstyle={passwordTextStyle}
                        design={passwordDesign}
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => {
                            handlePasswordChange(e.target.value);
                            setFormErrors(prev => ({ ...prev, password: false }));
                        }}
                        //error={formErrors.password || (!isPasswordValid && passwordTouched && password.length > 0)}
                        // errorMessage="Weak Password"
                        //errorTextStyle={classes.errorTextStyle}
                        //success={isPasswordValid && passwordTouched}
                        //successMessage="Strong Password"
                        successTextStyle={classes.successTextStyle}
                        borderline={false}
                        endAdornment={(
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOffOutlined style={{ color: '#171717' }} /> : <VisibilityOutlined style={{ color: '#171717' }} />}
                            </IconButton>
                        )}
                        disabled={disabledBtn}
                    />
                    {passwordTouched && !(isPasswordValid) && (
                        <div style={{ marginBottom: 15, marginTop: -15 }}>
                            <CustomText style={{ fontWeight: 'bold', marginBottom: 8 }}>
                                Password requirements:
                            </CustomText>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {password.length >= 8 ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: password.length >= 8 ? '#10B981' : '#EF4444', fontWeight: '400' }}>Minimum 8 Characters</CustomText>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {/[A-Z]/.test(password) ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: /[A-Z]/.test(password) ? '#10B981' : '#EF4444', fontWeight: '400' }}>At least 1 uppercase</CustomText>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {/[a-z]/.test(password) ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: /[a-z]/.test(password) ? '#10B981' : '#EF4444', fontWeight: '400' }}>At least 1 lowercase</CustomText>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {/\d/.test(password) ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: /\d/.test(password) ? '#10B981' : '#EF4444', fontWeight: '400' }}>At least 1 number</CustomText>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    {/[^A-Za-z0-9]/.test(password) ? (
                                        <CheckIcon style={{ color: '#10B981', fontSize: 16, marginRight: 4 }} />
                                    ) : (
                                        <CancelIcon style={{ color: '#EF4444', fontSize: 16, marginRight: 4 }} />
                                    )}
                                    <CustomText style={{ color: /[^A-Za-z0-9]/.test(password) ? '#10B981' : '#EF4444', fontWeight: '400' }}>At least 1 special character</CustomText>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Re-type Password */}
                    <CustomTextInput
                        title="Confirm Password"
                        textstyle={retypeTextStyle}
                        design={disabledBtn ? classes.textInputContainerDis : retypeDesign}
                        fullWidth
                        type={showRetypePassword ? 'text' : 'password'}
                        value={retypePassword}
                        onChange={(e) => {
                            handleRetypePasswordChange(e.target.value);
                            setFormErrors(prev => ({ ...prev, retypePassword: false }));
                        }}
                        error={formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)}
                        errorMessage={!retypePassword ? "Please confirm your password." : "Passwords do not match."}
                        errorTextStyle={classes.errorTextStyle}
                        borderline={false}
                        endAdornment={(
                            <IconButton
                                aria-label="toggle retype password visibility"
                                onClick={handleClickShowRetypePassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showRetypePassword ? <VisibilityOffOutlined style={{ color: '#171717' }} /> : <VisibilityOutlined style={{ color: '#171717' }} />}
                            </IconButton>
                        )}
                        disabled={disabledBtn}
                    />
                </div>
                {/* Confirm Button */}
                <div style={{ width: '100%', marginTop: '1rem' }}>
                    <CustomButton
                        title="Confirm"
                        design={isFormInvalid || updateClientInfoV4Loading || disabledBtn || isLoading ? classes.disableBtnStyle :classes.buttonStyle}
                        onClick={onClickConfirm}
                        disabled={isFormInvalid || updateClientInfoV4Loading || disabledBtn || isLoading}
                    />
                </div>
            </div>
        );
    };
    const renderMaintenanceChild = () => <></>;
    const height = 800;
    const width = 600;
    const modalContainer = () => {
        return (
            <div className={classes.containerStyle}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className={classes.tooltipContainer}>
                            <CustomText design={classes.titleTextStyle} style={{ marginBottom: 10 }}>
                                {customerDetails?.Data?.Message || "Something went wrong, Please retry later."}
                            </CustomText>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    };
    const onClickNextButton = () => {
        history.push("/")
    };
    return (
        <>
            <CustomBoardNewLogin
                maintenanceChild={renderMaintenanceChild()}
                children={renderPage()}
                height={height}
                width={width}
                isFixWidth={true}
            />
            <CustomToast
                open={customToastStatus}
                handleCloseCustomToast={handleCloseCustomToast}
                title={toastMessage}
                backToHome={backToHome}
                warning
            />
            <CustomModal
                open={isVisible}
                modalDesign={classes.modalDesign}
                submitButtonText={"OK"}
                modalComponent={modalContainer()}
                disableBackdropClick
                handleSubmitButton={() => onClickNextButton()}
                isVisibleCloseButton={false}
                okBtnSty={true}
            />
            {(updateClientInfoV4Loading || getLoginTokenLoading || isLoading) && <LoadingOverlay loading={true} />}
        </>
    );
};
export default CreateUserIDPass;